import React from 'react';
import { User, UserForm } from '../utils/types';

interface UserModalProps {
  isOpen: boolean;
  user: User | null;
  userForm: UserForm;
  currentUserRole: string;
  onClose: () => void;
  onUpdateUser: () => void;
  onUserFormChange: (form: UserForm) => void;
}

const UserModal: React.FC<UserModalProps> = ({
  isOpen,
  user,
  userForm,
  currentUserRole,
  onClose,
  onUpdateUser,
  onUserFormChange
}) => {
  if (!isOpen || !user) return null;

  const handleChange = (field: keyof UserForm, value: string) => {
    onUserFormChange({
      ...userForm,
      [field]: value
    });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2 sm:p-4 backdrop-blur-sm">
      <div className="bg-white rounded-lg max-w-full sm:max-w-md w-full shadow-2xl mx-2 sm:mx-4">
        <div className="flex items-center justify-between p-4 sm:p-6 border-b bg-gradient-to-r from-blue-50 to-white">
          <h3 className="text-lg sm:text-xl font-semibold text-gray-900">Modifier l'utilisateur</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 p-2 hover:bg-gray-200 rounded-full transition-all duration-300"
          >
            <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="p-4 sm:p-6">
          <div className="space-y-3 sm:space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Nom d'utilisateur</label>
              <input
                type="text"
                value={userForm.username}
                onChange={(e) => handleChange('username', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
              <input
                type="email"
                value={userForm.email}
                onChange={(e) => handleChange('email', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Nouveau mot de passe (optionnel)</label>
              <input
                type="password"
                value={userForm.password}
                onChange={(e) => handleChange('password', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                placeholder="Laisser vide pour ne pas changer"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Rôle</label>
              <select
                value={userForm.role}
                onChange={(e) => handleChange('role', e.target.value as any)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
              >
                {currentUserRole === 'super_admin' ? (
                  <>
                    <option value="super_admin">Super Admin</option>
                    <option value="admin_bank">Administrateur de la banque</option>
                  </>
                ) : (
                  <>
                    <option value="superviseur">Superviseur</option>
                    <option value="agent_saisie">Agent de Saisie</option>
                    <option value="auditeur">Auditeur</option>
                    <option value="conformité">Conformité</option>
                  </>
                )}
              </select>
            </div>
          </div>

          <div className="mt-4 sm:mt-6 flex justify-end space-x-2 sm:space-x-3">
            <button
              onClick={onClose}
              className="px-3 sm:px-4 py-2 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg transition-all duration-300 text-sm"
            >
              Annuler
            </button>
            <button
              onClick={onUpdateUser}
              className="px-3 sm:px-4 py-2 text-white bg-green-600 hover:bg-green-700 rounded-lg transition-all duration-300 text-sm"
            >
              Sauvegarder
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserModal;
